const rootRoutes = [
    '/login',
    '/receiveMode'
];

export const routes = {
    rootRoutes,
}